import "./App.css";

import {GridPerfil} from "./componentes/grid/grid1";



import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";



function App() {
  return (
<>
<section id="home" className="background">
<GridPerfil/>

</section>
</>
  );
}

export default App;
